// extracted by mini-css-extract-plugin
export var filterIncDec = "_d6-0";
export var leftBorder = "_d6-1";
export var rightBorder = "_d6-2";
export var stringInput = "_d6-3";